<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapState,mapGetters,mapActions } from "vuex"
import Swal from "sweetalert2";
import { ModelListSelect } from "vue-search-select";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Customers",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect
  },
  data() {
    return {
      title: "Customers ",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Customers",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "name",
          sortable: true,
          label: "NAME",
        },
        {
          key: "phone",
          sortable: true,
          label: "CONTACT",
        },
        {
          key: "brokername",
          sortable: true,
          label: "BROKER NAME",
        },
        {
          key: "brokerphone",
          sortable: true,
          label: "BROKER CONTACT",
        },
        {
          key: "addedon",
          sortable: true,
          label: "RECORDED ON",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      existingCustomer: [],
      nameError: "",
      contactError: "",

      // Value from user input for adding unit
      data: {
        name: "",
        contact: "",
        phone: "",
        brokername: "",
        brokercontact: "",
        brokerphone: "",
      },
      // edit unit
      editdata: {
        name: "",
        contact: "",
        id: "",
      },
      // delete unit
      deletedata: {
        name: "",
        id: "",
      },

      // merge data
      mergedata:{
        name: "",
        customer: "",
        id:""
      }
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("customers", ["SaveStatus", "Customers"]),
    ...mapGetters("auth", ["MyUserPerm","branchid"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.Customers ? this.Customers.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Customers ? this.Customers.length : 1;
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchCustomers: "customers/fetchCustomers",
      AddCustomer: "customers/addCustomer",
      EditCustomer: "customers/editCustomer",
      DeleteCustomer: "customers/deleteCustomer",
      MergeCustomer: "customers/mergeCustomer",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },



    addCustomer(modalId) {
      this.modal_id = modalId;

      if (this.data.name === "") {
        this.nameError = "Name  field is required";
        return;
      } else {
        this.nameError = "";
      }
      this.validateCustomer()
      if (this.contactError!=""){
        return
      }

      this.AddCustomer(this.data);
    },

    validateCustomer(){
      if (this.data.name !="" && this.data.contact!=''){
        let selCust = this.Customers.filter((item)=>{
          return  item.phone ==  parseInt(this.data.contact) ;
        })
        let custCount =selCust.length;
        if (custCount>0){
          this.contactError="Customer with contact "+this.data.contact+"  already Exists";
        }
      }else if(this.data.name !="" && this.data.contact ==''){
        let selCust = this.Customers.filter((item)=>{
          return  (item.name).toLowerCase() ==  (this.data.name).toLowerCase() ;
        })
        let custCount =selCust.length;
        if (custCount>0){
          this.contactError="Customer with these details already Exists";
        }
      }

    },

    redirect(value) {
      this.$router.push(
        `/customer/balance_details/${(value)}`
      );
    },

    resetAdd() {
      this.data.name = "";
      this.data.contact = "";
      this.data.phone = "";
      this.data.brokercontact = "";
      this.data.brokerphone = "";
      this.data.brokername = "";
      this.modal_id = "";
    },
    resetEdit() {
      this.data.name = "";
      this.data.id = "";
      this.modal_id = "";
    },

    resetDelete() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetError() {
      this.nameError = "";
      this.contactError = "";
    },
    showEditModal(val) {
      this.editdata.name = val.item.name;
      this.editdata.contact = val.item.phone;
      this.editdata.id = val.item.id;
    },
    editCustomer(modalId) {
      this.modal_id = modalId;
      this.validateCustomerEdit()
      if (this.contactError!=""){
        return
      }
      this.EditCustomer(this.editdata);
    },
    validateCustomerEdit(){
      if (this.editdata.name !="" && this.editdata.contact!=''){
        let selCust = this.Customers.filter((item)=>{
          return  (item.phone ==  parseInt(this.editdata.contact)) && (item.id != this.editdata.id) ;
        })
        let custCount =selCust.length;
        if (custCount>0){
          this.contactError="Customer with contact "+this.editdata.contact+"  already Exists";
        }
      }else if(this.editdata.name !="" && this.editdata.contact ==''){
        let selCust = this.Customers.filter((item)=>{
          return  (item.name).toLowerCase() ==  (this.editdata.name).toLowerCase() ;
        })
        let custCount =selCust.length;
        if (custCount>0){
          this.contactError="Customer with these details already Exists";
        }
      }

    },
    showDeleteModal(val) {
      this.deletedata.name = val.item.name;
      this.deletedata.id = val.item.id;
    },
    deleteCustomer(modalId) {
      this.modal_id = modalId;
      this.DeleteCustomer(this.deletedata);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    showMergeModal(data){
      this.mergedata.name = data.item.name;
      this.mergedata.id = data.item.id;
    },

    mergeCustomer(modalId) {
      this.modal_id = modalId;
      this.MergeCustomer(this.mergedata);
    },

    resetMerge() {
      this.mergedata.name = "";
      this.mergedata.id = "";
      this.modal_id = "";
    },
  },
  created() {
    this.FetchCustomers();

  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h4 class="card-title">Customers</h4>
              </div>
              <div v-if="MyUserPerm.add_customers == 1 && branchid != 0" class="col-md-3" align="right">
                <b-button v-b-modal.add-customer-modal variant="primary"><i class="fa fa-plus"></i> Add New</b-button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="Customers?Customers:[]"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(actions)="data">
                <b-button-group>
                  <b-button
                      v-if="MyUserPerm.edit_customers == 1"
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-product-modal
                      @click="showEditModal(data)"
                  ><i class="fa fa-edit"></i></b-button
                  >
                  <b-button
                      size="sm"
                      v-if="MyUserPerm.delete_customers == 1"
                      variant="danger"
                      v-b-modal.delete-product-modal
                      @click="showDeleteModal(data)"
                  ><i class="fa fa-trash"></i></b-button
                  >
                  <b-button
                    size="sm"
                    variant="success"
                    @click="redirect(data.item.id)"
                    ><i class="fa fa-user"></i>Profile</b-button
                  >
                  <b-button
                    v-if="MyUserPerm.edit_customers == 1"
                    size="sm"
                    variant="info"
                    v-b-modal.merge-customer-modal
                    @click="showMergeModal(data)"
                    ><i class="fa fa-pencil-alt"></i> Merge</b-button
                  >
                </b-button-group>
                </template>
              </b-table>
            </div>
            <Loader  v-if="!Customers"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal starts -->
    <b-modal id="add-customer-modal" hide-footer @hidden="resetAdd">
      <template #modal-title> Add Customer </template>

      <div class="form-group mb-3">
        <label>Customer Name <span class="text-danger">*</span></label>
        <div class="input-group">
          <input
              type="text"
              placeholder="Enter Name "
              class="form-control"
              @input="resetError()"
              v-model="data.name"
          />
        </div>
        <div class="text-danger" v-if="nameError">
          <em>{{ nameError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Customer Contact 1</label>
        <div class="input-group">
          <input
              type="number"
              placeholder="Enter Phone Number"
              class="form-control"
              v-model="data.contact"
              @input="resetError()"

          />
        </div>
        <div class="text-danger" v-if="contactError">
          <em>{{ contactError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Customer Contact 2</label>
        <div class="input-group">
          <input
              type="number"
              placeholder="Enter Phone Number"
              class="form-control"
              v-model="data.phone"
          />
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Broker Name <span class="text-danger">*</span></label>
        <div class="input-group">
          <input
              type="text"
              placeholder="Enter Name "
              class="form-control"
              @input="resetError()"
              v-model="data.brokername"
          />
        </div>
        <div class="text-danger" v-if="nameError">
          <em>{{ nameError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Broker Contact 1</label>
        <div class="input-group">
          <input
              type="number"
              placeholder="Enter Phone Number"
              class="form-control"
              v-model="data.brokercontact"
              @input="resetError()"

          />
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Broker Contact 2</label>
        <div class="input-group">
          <input
              type="number"
              placeholder="Enter Phone Number"
              class="form-control"
              v-model="data.brokerphone"
          />
        </div>
      </div>

      <div class="modal-footer">
        <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('add-customer-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
            type="button"
            class="btn btn-primary"
            @click="addCustomer('add-customer-modal')"
        > <i class="fa fa-check"></i>
          Submit
          <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Spinning"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
<!--     edit modal starts-->
        <b-modal id="edit-product-modal" hide-footer @hidden="resetEdit">
          <template #modal-title> Edit Customer {{ editdata.name }}</template>
          <div class="form-group mb-3">
            <label>Customer Name <span class="text-danger">*</span></label>
            <div class="input-group">
              <input
                  type="text"
                  class="form-control"
                  @input="resetError()"
                  v-model="editdata.name"
              />
            </div>
            <div class="text-danger" v-if="nameError">
              <em>{{ nameError }}</em>
            </div>
          </div>
          <div class="form-group mb-3">
            <label>Contact</label>
            <input
                type="number"
                class="form-control"
                @input="resetError()"
                v-model="editdata.contact"
            />

            <div class="text-danger" v-if="contactError">
              <em>{{ contactError }}</em>
            </div>
          </div>
          <div class="modal-footer">
            <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
                @click="closeModal('edit-product-modal')"
            >
              <i class="fa fa-times"></i> Close
            </button>
            <button
                type="button"
                class="btn btn-primary"
                @click="editCustomer('edit-product-modal')"
            > <i class="fa fa-check"></i>
              Save Changes
              <b-spinner
                  v-if="SaveStatus"
                  variant="light"
                  small
                  label="Saving"
              ></b-spinner>
            </button>
          </div>
        </b-modal>
    <!-- modal ends -->

    <!-- modal delete product starts -->
    <b-modal
        header-bg-variant="danger"
        header-text-variant="light"
        body-text-variant="danger"
        footer-bg-variant="danger"
        footer-text-variant="danger"
        id="delete-product-modal"
        hide-footer
        @hidden="resetDelete"
    >
      <template #modal-title> Delete Customer {{ deletedata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>
            Do you want to delete this record? Click Proceed Button to delete.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-product-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
            type="button"
            class="btn btn-danger"
            @click="deleteCustomer('delete-product-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- map modal starts -->
    <b-modal id="merge-customer-modal" hide-footer @hidden="resetMerge">
      <template #modal-title> Merge Customer {{ mergedata.name }}</template>
      <div class="form-group mb-3">
        <label>Merge into Customer <span class="text-danger">*</span></label>
        <div class="input-group">
          <model-list-select
            :list="Customers ? Customers : []"
            v-model="mergedata.customer"
            option-value="id"
            option-text="name"
            class="mb-3"
            @input="resetError()"
          >
          </model-list-select>
        </div>
        <div class="text-danger" v-if="nameError">
          <em>{{ nameError }}</em>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('merge-customer-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="mergeCustomer('merge-customer-modal')"
        > <i class="fa fa-check"></i>
          Save Changes
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Saving"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- map modal ends -->
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
.btn-xs {
  padding: .25rem .4rem;
  font-size: .875rem;
  line-height: .5;
  border-radius: .2rem;
}
</style>
